const MATH_SELECTOR = '[data-math-source]';
const BLOCK_TAGS = new Set(['DIV', 'P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'LI', 'UL', 'OL', 'PRE', 'BLOCKQUOTE', 'TR']);

/** The exact original delimiter literal also survives lazy/error fallbacks. */
export function mathSourceLiteral(text, display, source) {
  return source || `${display ? '\\[' : '\\('}${text}${display ? '\\]' : '\\)'}`;
}

function clonedSourceText(fragment) {
  // KaTeX contains both MathML and visual HTML. Replace their shared wrapper
  // once, rather than reading either rendering as a new mathematical formula.
  fragment.querySelectorAll(MATH_SELECTOR).forEach((node) => {
    node.replaceWith(node.ownerDocument.createTextNode(node.getAttribute('data-math-source')));
  });
  const read = (node) => {
    if (node.nodeType === 3) return node.nodeValue || '';
    if (node.nodeType !== 1 && node.nodeType !== 11) return '';
    if (node.nodeName === 'BR') return '\n';
    const text = Array.from(node.childNodes).map(read).join('');
    if (BLOCK_TAGS.has(node.nodeName)) return `\n${text}\n`;
    if (node.nodeName === 'TD' || node.nodeName === 'TH') return `${text}\t`;
    return text;
  };
  return read(fragment).replace(/^\n+|\n+$/g, '');
}

/** Full visible text, with each rendered formula represented by its source. */
export function quoteTextOf(node) {
  if (!node) return '';
  if (node.nodeType === 1 && node.hasAttribute('data-math-source')) return node.getAttribute('data-math-source');
  if (!node.querySelector(MATH_SELECTOR)) return node.innerText || node.textContent || '';
  return clonedSourceText(node.cloneNode(true));
}

/** Keep normal selections exact; a touched formula is quoted as one atom. */
export function selectedQuoteText(selection, root) {
  if (!selection || !root) return '';
  const original = selection.toString();
  if (!selection.rangeCount || typeof selection.getRangeAt !== 'function') return original;
  const range = selection.getRangeAt(0).cloneRange();
  // A short selection must not traverse the whole answer (which may include a
  // large diagnostic transcript). Its common ancestor bounds the only formulas
  // it can touch. A selection inside KaTeX still expands to the outer atom.
  const common = range.commonAncestorContainer;
  const element = common.nodeType === 1 ? common : common.parentElement;
  const atom = element?.closest(MATH_SELECTOR);
  const nodes = atom && (atom === root || root.contains(atom))
    ? [atom]
    : common.nodeType === 1 && (common === root || root.contains(common))
      ? Array.from(common.querySelectorAll(MATH_SELECTOR))
      : [];
  const formulas = nodes.filter((node) => range.intersectsNode(node));
  if (!formulas.length) return original;
  formulas.forEach((node) => {
    const whole = node.ownerDocument.createRange();
    whole.selectNode(node);
    if (range.compareBoundaryPoints(0, whole) > 0) range.setStartBefore(node);
    if (range.compareBoundaryPoints(2, whole) < 0) range.setEndAfter(node);
  });
  return clonedSourceText(range.cloneContents());
}
